import { Factory } from 'miragejs';

export default Factory.extend({
  fileUrl: 'https://picsum.photos/600/600',
  file: 'covid-card-welcome-bg.png',
});
